<div class="modal-content" piqetAngularDraggable>
  <div class="modal-header header-modal">
    <h2 class="modal-title ml-auto pl-5" id="exampleModalLabel">
      <div class="bootstrap-dialog-title" id="dialogMaterialCreate_title">{{ modalLabel }}</div>
    </h2>
    <button type="button" class="closeModal pull-right" aria-label="Close" (click)="onClose()">
      <img src="./assets/icons/pop-up-cross.svg" width="16" height="17" />
    </button>
  </div>
  <div class="modal-body body-modal">
    <form [formGroup]="organizationForm">
      <div class="mb-3 d-flex justify-content-end align-items-center">
        <a
          class="add-link"
          target="_blank"
          routerLink="administrator/user-management/adminOrganization"
          ><span class="redirectLinkText"> Add organization</span></a
        >
        <a
          class="setLinkIconPosition"
          target="_blank"
          replaceUrl="true"
          routerLink="administrator/user-management/adminOrganization"
        >
          <img src="./assets/icons/redirect-icon.svg" alt="" width="15" height="13" />
        </a>
        <span class="setLinkIconPosition" (click)="getOrganizationList()"
          ><img src="./assets/icons/refresh-circle.svg" alt="" width="14" height="13"
        /></span>
      </div>
      <div class="row">
        <div class="col-sm-12">
          <div class="form-group">
            <label
              *ngIf="organizationForm.controls['organizationOne']?.value"
              class="sub-header-drpdown pb-2"
            >
              From organization *
            </label>
            <ng-select
              [clearable]="true"
              [clearOnBackspace]="false"
              [items]="filteredOrganizationListOne"
              #select1
              [searchable]="false"
              bindLabel="name"
              formControlName="organizationOne"
              [searchFn]="commonInputSearch"
              placeholder="From organization *"
              [multiple]="true"
            >
              <ng-template ng-header-tmp>
                <div class="has-feedback">
                  <input
                    type="text"
                    class="form-control accordion-search search-input"
                    id="inputValidation"
                    (input)="select1.filter($any($event.target).value)"
                    placeholder="Search..."
                  />
                  <span class="form-control-feedback">
                    <i class="fa fa-search icon"></i>
                  </span>
                </div>
              </ng-template>
              <ng-template ng-option-tmp let-item="item" let-search="searchTerm">
                <div [ngOptionHighlight]="search" title="{{ item?.description }}">
                  {{ item.name }}
                </div>
              </ng-template>
            </ng-select>
            <div
              *ngIf="submitted && organizationForm.controls['organizationOne']?.invalid"
              class="input-error"
            >
              Please select from organization.
            </div>
          </div>
        </div>
      </div>
      <div class="row">
        <div class="col-sm-12">
          <div class="form-group">
            <label
              *ngIf="organizationForm.controls['organizationTwo']?.value"
              class="sub-header-drpdown pb-2"
            >
              To organization *
            </label>
            <ng-select
              [clearable]="true"
              [clearOnBackspace]="false"
              [items]="filteredOrganizationListTwo"
              #select2
              [searchable]="false"
              bindLabel="name"
              formControlName="organizationTwo"
              [searchFn]="commonInputSearch"
              placeholder="To organization *"
            >
              <ng-template ng-header-tmp>
                <div class="has-feedback">
                  <input
                    type="text"
                    class="form-control accordion-search search-input"
                    id="inputValidation"
                    (input)="select2.filter($any($event.target).value)"
                    placeholder="Search..."
                  />
                  <span class="form-control-feedback">
                    <i class="fa fa-search icon"></i>
                  </span>
                </div>
              </ng-template>
              <ng-template ng-option-tmp let-item="item" let-search="searchTerm">
                <div [ngOptionHighlight]="search" title="{{ item?.description }}">
                  {{ item.name }}
                </div>
              </ng-template>
            </ng-select>
            <div
              *ngIf="submitted && organizationForm.controls['organizationTwo']?.invalid"
              class="input-error"
            >
              Please select to organization.
            </div>
          </div>
        </div>
      </div>

      <div class="row pb-3">
        <div class="col-6 services-form-no-label">
          <label
            ><b>Note:</b> The selected date and time will be in Coordinated Universal Time (UTC)
            format.</label
          >
        </div>
      </div>

      <div class="row">
        <div class="col-sm-4">
          <div class="col-xs-12 col-12 col-md-12">
            <div aria-required="true" class="d-flex">
              <div class="services-form-no-label">
                <label>Date</label>
                <input
                  type="text"
                  [bsConfig]="datePickerConfig"
                  #hiddenExpry
                  placeholder="Select merger date"
                  [bsValue]="bsValue"
                  (bsValueChange)="onValueChange($event)"
                  bsDatepicker
                  [readonly]="true"
                  [minDate]="minDate"
                />
                <div class="calendar-icon">
                  <span class="input-group-text">
                    <img
                      (click)="hiddenExpry.click()"
                      src="assets/icons/calendar.svg"
                      width="16"
                      height="16"
                    />
                  </span>
                </div>
              </div>
              <div class="services-form-no-label ps-5">
                <label>Time</label>
                <input type="time" (change)="onTimeChange($event)" [value]="timeVal" />
              </div>
            </div>
          </div>
        </div>
      </div>
    </form>
  </div>

  <div *ngIf="validationMsg" class="input-error pt-4">
    <div class="pb-4">{{ validationMsg }}</div>
    <table class="table table-striped table-bordered table-hover">
      <thead>
        <tr>
          <th>Organization</th>
          <th>Role</th>
          <th>User count</th>
        </tr>
      </thead>
      <tbody>
        <tr *ngFor="let org of errorTable">
          <td>
            <a
              id="black-def"
              routerLinkActive="active"
              target="_blank"
              [routerLink]="[
                'administrator/user-management/adminOrganization/details',
                org.organizationId
              ]"
              >{{ org.organizationName }}</a
            >
          </td>
          <td *ngIf="!org.isTarget">Source</td>
          <td *ngIf="org.isTarget">Target</td>
          <td>{{ org.userLimit }}</td>
        </tr>
      </tbody>
    </table>
  </div>

  <div class="modal-footer box-footer">
    <button type="button " class="cancelBtn" (click)="onClose()">Cancel</button>
    <button type="button " class="modelBtn purpleBtnHoverEffect" (click)="onSave()">Save</button>
  </div>
</div>
